import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ViewPortUtil from '../../../helpers/ViewPortUtil'
import CustomButton from '../CustomButton'
import './style.sass'

const FloatingBottomActionsBar = ({
  mainText,
  // Primary action
  primaryButtonText,
  onPrimaryButtonPressed,
  isProccessingPrimaryAction,
  primaryButtonClass = "btn-fill",
  // Secondary action
  secondaryButtonText,
  onSecondaryButtonPressed,
  isProccessingSecondaryAction,
  secondaryButtonClass = "btn-outline",
}) => {
  const footer = document.getElementById('footer-id')
  const [marginBottom, setMargin] = useState(0)

  useEffect(() => {
    const onScroll = () => {
      setMargin(ViewPortUtil.isVisibleInViewport(footer))
    }
    window.addEventListener('scroll', onScroll)
    return (() => { window.removeEventListener('scroll', onScroll) })
  }, [])

  return (
    <div className='floating-bottom-actions-bar-container' style={{ marginBottom: marginBottom }}>
      <p>{mainText}</p>
      <div className='actions'>
        {!primaryButtonText || (
          <CustomButton
            className={`btn ${primaryButtonClass}`}
            buttonText={primaryButtonText}
            onClick={onPrimaryButtonPressed}
            disabled={isProccessingPrimaryAction || isProccessingSecondaryAction}
          />
        )}
        {!secondaryButtonText || (
          <CustomButton
            className={`btn ${secondaryButtonClass}`}
            buttonText={secondaryButtonText}
            onClick={onSecondaryButtonPressed}
            disabled={isProccessingPrimaryAction || isProccessingSecondaryAction}
          />
        )}
      </div>
    </div>
  )
}

FloatingBottomActionsBar.propTypes = {
  mainText: PropTypes.string,
  // Primary action
  primaryButtonText: PropTypes.string,
  onPrimaryButtonPressed: PropTypes.func,
  isProccessingPrimaryAction: PropTypes.bool,
  // Secondary action
  secondaryButtonText: PropTypes.string,
  onSecondaryButtonPressed: PropTypes.func,
  isProccessingSecondaryAction: PropTypes.bool,
}


export default FloatingBottomActionsBar